import axios from 'axios'
import errorHandlerRest from './errorHandlerRest'
import { Cookie } from '@/mixin/local-cookie'

const axiosConfig = {
  baseURL: process.env.VUE_APP_REST_API_VSMS,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

// When developing locally, the cookie 'resource' cookie is not available
// in the browser (httpOnly).
// So we need to manually copy the cookie after identity login
// and paste it to the localhost cookie
const localCookie = Cookie.getLocalCookie()

// If the local cookie is found (not httpOnly), then use it
// if not, then use the httpOnly cookie, using withCredentials flag
if (localCookie?.resource) {
  axiosConfig.headers.Authorization = `Bearer ${localCookie?.resource}`
} else {
  axiosConfig.withCredentials = true
}

const apiClient = axios.create(axiosConfig)

// NOTE: do not delete.
// Use this to emulate api error, `config` has url, method, data (body), etc
// apiClient.interceptors.request.use((config) => {
//   return Promise.reject({
//     response: {
//       status: 404,
//       data: {
//         message: 'Not found',
//       },
//     },
//   })
// })

apiClient.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return errorHandlerRest(error)
  }
)

export default apiClient
